export const noop = () => {};
export const noopWithValue = (returnValue = undefined) => returnValue;
